import * as Utils from "Core/Utils/Utils";
// App
import { BaseStore } from "../../../Core/Stores/BaseStore";
import { action, computed, observable } from "mobx";
import { Stores } from "../Stores";
import { InitialState } from "Custom/Models";
import { UserAccessModelDTO } from "Custom/Models/Domain/UserAccess/UserAccessModel";
import { QuoteUserDetailsDTO, GetDefaultQuoteUserDetailsDTO } from "Custom/Models/Domain/UserAccess/QuoteUserDetailsDTO";

export class AccountStore extends BaseStore {
    private readonly cookieName: string = ".bsqauth";
    @observable public hasUserAccess: boolean = false;
    @observable public userEmail: string = "";
    @observable public projectName: string = "";

    @observable public useAdminGrids: boolean = false;
    @observable public useAdminControlsLight: boolean = false;
    @observable public isSubmitted: boolean = false;

    public constructor() {
        super();
    }

    public init(stores: Stores, initialState: InitialState) {
        this.useAdminGrids = initialState.appSettings.useAdminGrids === "true";
        this.useAdminControlsLight = initialState.appSettings.useAdminControlsLight === "true";
        // see if we have data already
        const data = this.getUserState();
    }

    @action
    public Logout = (redirect: boolean = false): void => {
        try {
            localStorage.removeItem(this.cookieName);
            document.cookie = ".refreshtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            this.hasUserAccess = false;
            this.userEmail = "";

            if (redirect) {
                window.location.href = "/";
            }
        } catch (e) {
            if (window.location.href.indexOf("/cookieerror") === -1) {
                window.location.href = "/cookieerror";
            }
        }
    };

    @action
    private parseCookie = (cookie: string): UserAccessModelDTO | undefined => {
        let retVal: UserAccessModelDTO | undefined = undefined;
        retVal = JSON.parse(cookie);
        return retVal;
    };

    @action
    public getUserState = () => {
        let retVal: UserAccessModelDTO | undefined = undefined;
        try {
            let cookie: string = localStorage.getItem(this.cookieName) as string;

            if (cookie && cookie !== "undefined" && cookie !== "null") {
                const data: UserAccessModelDTO | undefined = this.parseCookie(cookie);

                if (data === undefined) {
                    this.hasUserAccess = false;
                    retVal = data;
                    return;
                }

                this.hasUserAccess = true;
                this.userEmail = data.email;
            }
            return retVal;
        } catch (e) {
            if (window.location.href.indexOf("/cookieerror") === -1) {
                window.location.href = "/cookieerror";
            }
        }
    };

    @action
    public getUserDetailsForEmail = () => {
        try {
            let retVal: QuoteUserDetailsDTO = GetDefaultQuoteUserDetailsDTO();
            let cookie: string = localStorage.getItem(this.cookieName) as string;

            if (cookie && cookie !== "undefined" && cookie !== "null") {
                const data: UserAccessModelDTO | undefined = this.parseCookie(cookie);

                if (data === undefined) {
                    this.hasUserAccess = false;
                    return retVal;
                }

                retVal.allowMarketing = data.allowMarketing;
                retVal.email = data.email;
                retVal.displayName = data.displayName;
                retVal.projectName = this.projectName;
                retVal.telephone = data.telephone;
                retVal.company = data.company;
            }
            return retVal;
        } catch (e) {
            if (window.location.href.indexOf("/cookieerror") === -1) {
                window.location.href = "/cookieerror";
            }
        }
    };

    @action
    public setUserState = (data: UserAccessModelDTO) => {
        try {
            localStorage.removeItem(this.cookieName);
            document.cookie = ".refreshtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
            this.hasUserAccess = false;

            if (data !== undefined) {
                const json = JSON.stringify(data);
                localStorage.setItem(this.cookieName, json);
                this.hasUserAccess = true;
                this.userEmail = data.email;
            }
        } catch (e) {
            if (window.location.href.indexOf("/cookieerror") === -1) {
                window.location.href = "/cookieerror";
            }
        }
    };

    @action
    public setEmailData = (email: string, project: string) => {
        try {
            let cookie: string = localStorage.getItem(this.cookieName) as string;

            if (cookie && cookie !== "undefined" && cookie !== "null") {
                const data: UserAccessModelDTO | undefined = this.parseCookie(cookie);

                if (data === undefined) {
                    this.hasUserAccess = false;
                    return;
                }
                // CMR Question asked as to whether we should do this or not.
                this.userEmail = email;
                data.email = email;
                this.projectName = project;
                this.setUserState(data);
            }
        } catch (e) {
            if (window.location.href.indexOf("/cookieerror") === -1) {
                window.location.href = "/cookieerror";
            }
        }
    };

    @computed get GetUseAdminGrids(): boolean {
        return this.useAdminGrids;
    }

    @computed get GetUseAdminControlsLight(): boolean {
        return this.useAdminControlsLight;
    }

    @computed get HasSubmitted(): boolean {
        return this.isSubmitted;
    }

    @action
    public setSubmitted = (value: boolean): void => {
        this.isSubmitted = value;
    };

    @action
    public resetUser = (): void => {
        localStorage.removeItem(this.cookieName);
        document.cookie = ".refreshtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        this.hasUserAccess = false;
        this.userEmail = "";
    };
}
